import i18next from '@bonanza-social/i18n';
import en from './en.json';

i18next.addResources('en', 'sof', en);

declare global {
  interface RegisteredLocales {
    sof: typeof en;
  }
}
